<template>
    <relatorio-page :titulo=" 'Relatório Doadores' " :cabecalhoCompleto="true" :exportarExcel="false" :paisagem="true">
            
        <v-row v-if="item.length > 0">

            <v-col cols="12">

                <v-simple-table id="tabela" dense class="py-2 text-caption" v-if="filter.exibirEndereco == 'false'">
                    <template v-slot: default>
                        <thead class="fonte" style="background-color: #4A70A8">
                            <tr>
                                <th style="font-size: 100% ; color: white" class="text-left fonte">CPF/CNPJ</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Nome</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Nasc./Fund.</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Telefone</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Celular</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Contribuição</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Proposto</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">E-mail</th>
                                <th style="font-size: 100% ; color: white" class="text-right fonte">Sit.</th>
                            </tr>
                        </thead>
                        <tbody class="fonte">
                            <tr v-for="(item, index) in item" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                <td style="font-size: 100%">{{item.cpfCnpj}}</td>
                                <td style="font-size: 100%">{{item.nome}}</td>
                                <td style="font-size: 100%">{{new Date(item.dataNascimentoFundacao).ddmmyyyy()}}</td>
                                <td style="font-size: 100%">{{item.telefone}}</td>
                                <td style="font-size: 100%">{{item.celular}}</td>
                                <td style="font-size: 100%">{{item.tipoContribuicaoStr}}</td>
                                <td style="font-size: 100%">{{item.doacaoProposta.toMoeda()}}</td>
                                <td style="font-size: 100%">{{item.email}}</td>
                                <td style="font-size: 100%">{{item.situacao}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

                <v-simple-table id="tabela" dense class="py-2 text-caption" v-else>
                    <template v-slot: default>
                        <thead class="fonte" style="background-color: #4A70A8">
                            <tr>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Nome</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">CEP</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Logradouro</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Bairro</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Cidade</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">UF</th>
                                <th style="font-size: 100% ; color: white" class="text-center fonte">Pais</th>
                            </tr>
                        </thead>
                        <tbody class="fonte">
                            <tr v-for="(item, index) in item" :key="index" :style=" index % 2 === 0 ? 'background-color: gainsboro' : 'background-color: White'">
                                <td style="font-size: 100%">{{item.nome}}</td>
                                <td style="font-size: 100%">{{item.cep}}</td>
                                <td style="font-size: 100%">{{item.logradouro}}</td>
                                <td style="font-size: 100%">{{item.bairro}}</td>
                                <td style="font-size: 100%">{{item.cidade}}</td>
                                <td style="font-size: 100%">{{item.estado}}</td>
                                <td style="font-size: 100%">{{item.pais}}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>

            </v-col>

        </v-row>

        <v-row v-else>
            <v-col cols="12">
                Nenhum registro foi encontrado.
            </v-col>
        </v-row>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
    </relatorio-page>
</template>

<script>
import DoadorService from '../../../core/services/doacao/DoadorService'
export default {
    
    data: () => ({
        item:{
            required: true
        },
        filter:{
            exibirEndereco: false
        },
        service: new DoadorService(),
        overlay: false
    }),
    props:{

    },
    mounted(){

        this.filter = this.$route.query;

        this.overlay = true

        this.service.FiltroComplementar(0,-1,[],[],null,[], this.filter).then(
            res=>{
                this.item = res.data.items;
            },
            err=>{
                this.$swal('Aviso', err.message, 'error');
            }
        ).finally(() => {
            this.overlay = false;
        })
    },
    methods:{

    }   

}
</script>

<style>
    .fonte{
        font-size: 70%;
    }
</style>
